export function findDuplicates<
  Type,
  Key extends keyof Type
>(
  array1: Type[],
  array2: Type[],
  find: keyof Type,
  property: Key
): Map<Type[Key], Type[Key]> {
  const array2Map = new Map(array2.map((item) => {
    return [item[find], item[property]];
  }));

  const replacements = new Map<Type[Key], Type[Key]>();
  for (const element1 of array1) {
    const element2Property = array2Map.get(element1[find]);
    if (array2Map.has(element1[find]) && element1[property] !== element2Property) {
      replacements.set(element1[property], element2Property!);
    }
  }

  return replacements;
}
